<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Butiran Akaun Perumahan" >
        <!--  <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitKontrak"
                @success="Success"
            > -->

    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      No. Akaun :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_akaun}} </div>
            </div>
            
            <div class="xs6">
                <h5 class="fw-semibold m0">
                      Harga Rumah (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.harga_rumah)}}
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Nama :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    <template v-for="dt, index in form.profil_perumahan_peminjam">
                        {{dt.nama_id}}
                    </template>
                    <template v-if="form.lkp_perumahan_premis_id == 2">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <w-tooltip top>
                          <template #activator="{ on }">
                            <w-icon v-on="on" @click="pemilikBaharu(form)">
                             fal fa-pencil
                            </w-icon>
                          </template>
                          Kemaskini
                        </w-tooltip>
                    </template>
                </div>
            </div>
            <div class="xs6">
                <h5 class="fw-semibold m0">
                      Jumlah Kutipan  (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.amaun_kutipan)}}
                </div>
            </div>
        </w-flex>

         <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Alamat :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    <template v-for="dt, index in form.profil_perumahan_peminjam">
                     {{dt.profil.alamat1}}
                    </template>
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                      Baki Harga Rumah (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.amaun_baki)}}
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      No. Rumah :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.no_rumah}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                      Patut Kutip (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.amaun_patut_kutip)}}
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Kod Premis :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.kod_premis}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                      Tunggakan Akaun Sewa Lama (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.amaun_tunggakan_lama)}}
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Jenis Skim :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.lkpPerumahan ? form.lkpPerumahan.kod_perumahan_jenis: '' }}
                </div>
            </div>
            <div class="xs6">
                <h5 class="fw-semibold m0">
                      Jumlah Tunggakan / Lebihan (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.amaun_tunggakan_lebihan)}}
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Skim Perumahan :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.no_skim}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                     Jumlah Lebihan Semasa (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.amaun_tunggakan_lebihan)}}
                  </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Status Premis :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.lkp_premis_keterangan}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                    No Deposit : 
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                        {{form.deposit1 ? form.deposit1.no_cagaran: ''}}
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Tarikh Perjanjian  :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.dateformat(form.tarikh_perjanjian)}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                     No Resit Deposit / Tarikh Bayar Deposit : 
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                     <template v-for="d, index in form.resit_deposit">
                    {{d ? d.no_resit : '' }} | {{$zutil.dateformat(d.tarikh_deposit_trans)}} <br>
                    </template>
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Tempoh Perjanjian :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.tempoh_perjanjian}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                    Jumlah Deposit : 
                  </h5>
                  <div class="fw-normal my1 fs-1"> 

                    <template v-if="form.deposit_trans">
                         <template v-for="d, index in form.deposit_trans">
                             {{$zutil.currency(d.amaun)}}<br>
                        </template>
                    </template>
                     <template v-else>
                        0.00
                    </template>
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Tarikh Mula Menduduki :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.dateformat(form.tarikh_mula_duduki)}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                    Tarikh Baucer Tuntutan Deposit :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    <template v-for="d, index in form.deposit_trans_bayaran">
                    {{$zutil.dateformat(d.created_at)}}
                    </template>
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Tarikh Akhir Menduduki :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.dateformat(form.tarikh_tamat_duduki)}}
                </div>
            </div>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                    No. Baucer Tuntutan Deposit :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    <template v-for="d, index in form.deposit_trans_bayaran">
                        {{d.no_kelulusan_bayaran}}
                    </template>
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Bulan Awal Sewa :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.dateformat(form.bulan_mula_bayar)}} 
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                    No. Baucer Tuntutan Lebihan :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Bulan Akhir Sewa :
                  </h5>
                  <div class="fw-normal my1 fs-1">
                    {{$zutil.dateformat(form.bulan_tamat_bayar)}} 
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                    Tarikh Jurnal :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Kadar Ansuran Bulanan (RM) :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{$zutil.currency(form.kadar_bulanan)}}
                </div>
            </div>
            <div class="xs6">
                <h5 class="fw-semibold m0">
                    No. Jurnal : 
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center>
            <div class="xs6">
                  <h5 class="fw-semibold m0">
                      Status :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 
                    {{form.status_keterangan}}
                </div>
            </div>
            <div class="xs6">
                 <h5 class="fw-semibold m0">
                    Potongan Gaji :
                  </h5>
                  <div class="fw-normal my1 fs-1">  
                    <template v-if="form.is_potongan_gaji == 1">
                        Ya
                    </template>
                    <template v-else>
                        Tidak
                    </template>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <w-tooltip top>
                          <template #activator="{ on }">
                            <w-icon v-on="on" @click="potongGaji(form)">
                             fal fa-pencil
                            </w-icon>
                          </template>
                          Kemaskini
                        </w-tooltip>
                </div>
            </div>
        </w-flex>
    </w-card>


    <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>

    <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">  
    <template #item-content.1>  

         <w-flex justify-center align-center>
            <div class="w-card__content content-hardcode">
                <template v-for="dt, index in form.perumahan_profil">
                     <w-flex justify-center align-center>
                        <div class="xs2">
                              <h5 class="fw-semibold m0">
                                  Penama {{(index+1)}} :
                              </h5>
                              <div class="fw-normal my1 fs-1">
                            </div>
                        </div>
                        <div class="xs6">
                        </div>
                        <div class="xs4">
                        </div>
                    </w-flex>

                    <w-flex justify-center align-center>
                       <div class="xs2">
                        </div>
                        <div class="xs6">
                            <h5 class="fw-semibold m0">
                                  Nama :
                              </h5>
                              <div class="fw-normal my1 fs-1">
                                {{dt.nama_id}}
                            </div>
                        </div>
                        <div class="xs4">
                        </div>
                    </w-flex>

                    <w-flex justify-center align-center>
                       <div class="xs2">
                        </div>
                        <div class="xs6">
                            <h5 class="fw-semibold m0">
                                  Alamat :
                              </h5>
                              <div class="fw-normal my1 fs-1">
                                {{dt.profil.alamat1}}
                            </div>
                        </div>
                        <div class="xs4">
                        </div>
                    </w-flex>
                </template>
            </div>
        </w-flex>
        <br>

    <template v-if="form.is_potongan_gaji == 1">
        <w-flex justify-center align-center>
            <div class="w-card__content content-hardcode">
                <w-flex justify-center align-center>
                    <div class="xs2">
                          <h5 class="fw-semibold m0">
                              Maklumat Potongan Gaji :
                          </h5>
                          <div class="fw-normal my1 fs-1">
                        </div>
                    </div>
                    <div class="xs6">
                    </div>
                    <div class="xs4">
                    </div>
                </w-flex>
                <br>
                <w-flex justify-center align-center>
                   <div class="xs2">
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">
                              Nama :
                          </h5>
                          <div class="fw-normal my1 fs-1">
                            {{form.profil_perumahan_pembayar ? form.profil_perumahan_pembayar.nama_id: ''}}
                        </div>
                    </div>
                    <div class="xs4">
                    </div>
                </w-flex>
                <br>
                <w-flex justify-center align-center>
                   <div class="xs2">
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">
                              Agensi :
                          </h5>
                          <div class="fw-normal my1 fs-1"> 
                            {{form.perumahan_pejabat ? form.perumahan_pejabat.pejabat: ''}}
                        </div>
                    </div>
                    <div class="xs4">
                    </div>
                </w-flex>
                <br>
                <w-flex justify-center align-center>
                   <div class="xs2">
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">
                              Jabatan :
                          </h5>
                          <div class="fw-normal my1 fs-1">
                            {{form.perumahan_pejabat ? form.perumahan_pejabat.kod: ''}} 

                            <template v-if="form.perumahan_pejabat_id != null"> | </template> {{form.perumahan_pejabat ? form.perumahan_pejabat.nama: ''}} 
                        </div>
                    </div>
                    <div class="xs4">
                    </div>
                </w-flex>
                <br>
                <w-flex justify-center align-center>
                   <div class="xs2">
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">
                              Bulan Mula | Tahun:
                          </h5>
                          <div class="fw-normal my1 fs-1">
                            {{form.perumahan_potongan_gaji ? form.perumahan_potongan_gaji.bulan_keterangan: ''}} -
                            {{form.perumahan_potongan_gaji ? form.perumahan_potongan_gaji.tahun: ''}} 
                        </div>
                    </div>
                    <div class="xs4">
                    </div>
                </w-flex>
                <br>
                <w-flex justify-center align-center>
                   <div class="xs2">
                    </div>
                    <div class="xs6">
                        <h5 class="fw-semibold m0">
                              Kadar Potongan Gaji (RM) :
                          </h5>
                          <div class="fw-normal my1 fs-1">
                            <template v-if="form.perumahan_pejabat_id != null">
                                <!-- {{$zutil.currency(form.kadar_bulanan)}} -->
                                {{$zutil.currency(form.perumahan_potongan_gaji ? form.perumahan_potongan_gaji.amaun : '')}}
                            </template>
                        </div>
                    </div>
                    <div class="xs4">
                    </div>
                </w-flex>
            </div>
        </w-flex>
    </template>



       
    </template>

      <template #item-content.2>

        <!-- <template v-for="dt, index in form.perumahanMaklumatDeposit"> -->

           <!--   <w-flex justify-center align-center>
                <div class="xs2">
                      <h5 class="fw-semibold m0">
                          Deposit {{(index+1)}} :
                      </h5>
                      <div class="fw-normal my1 fs-1">
                    </div>
                </div>
                <div class="xs3">
                </div>
                <div class="xs7">
                </div>
            </w-flex>
            <br> -->
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        No Deposit :
                    </h5>
                </div>
                <div class="xs9">
                    <w-tooltip top color="primary">
                        <template #activator="{ on }">
                            <span v-on="on" class="ma3">
                                <inertia-link :href='$route("deposit.show",form.deposit1.id)'>
                                    {{form.deposit1 ? form.deposit1.no_cagaran: ''}}
                                </inertia-link> 
                            </span>
                        </template>
                        Klik Paparan Deposit
                    </w-tooltip>
                        <!-- <a @click="Deposit"> -->
                        <!-- : {{dt.no_cagaran}} -->
                          <!--   {{form.deposit1 ? form.deposit1.no_cagaran: ''}}
                        </a> -->
                   <!--        
                    <w-tooltip top color="primary">
                        <template #activator="{ on }">
                          <span v-on="on" class="ma3">
                            <a @click="Deposit">
                                 <u>{{form.deposit1 ? form.deposit1.no_cagaran: ''}}</u>
                            </a>
                          </span>
                        </template>
                        Klik Paparan Deposit
                    </w-tooltip> -->
                </div>
            </w-flex>
            <br>
             <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        No. Resit :
                    </h5>
                </div>
                <div class="xs9">

                    <template v-for="d, index in form.resit_deposit">
                        <span class="ma3">
                            {{d ? d.no_resit : '' }}<br>
                        </span>
                    </template>
                </div>
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Tarikh Bayar Deposit :
                    </h5>
                </div>
                <div class="xs9">
                   <!--  <template v-for="d, index in form.deposit_trans">
                        {{$zutil.dateformat(d.created_at)}}<br>
                   </template> -->
                    <template v-for="d, index in form.resit_deposit">
                        <span class="ma3">
                            {{$zutil.dateformat(d.tarikh_deposit_trans)}}<br>
                        </span>
                   </template>
                </div>
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Amaun Deposit (RM): 
                    </h5>
                </div>
                <div class="xs9">
                    <template v-for="d, index in form.deposit_trans">
                        <span class="ma3">
                            {{$zutil.currency(d.amaun)}}<br>
                        </span>
                    </template>
                </div>
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        No Baucer Tuntutan Deposit :
                    </h5>
                </div>
                <div class="xs9">
                    <template v-for="d, index in form.deposit_trans_bayaran">
                        <span class="ma3">
                            {{d.no_kelulusan_bayaran}}
                        </span>
                    </template>
                </div>
            </w-flex>
            <br>

             <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Tarikh Baucer Tuntutan Deposit :
                    </h5>
                </div>
                <div class="xs9">
                    <template v-for="d, index in form.deposit_trans_bayaran">
                        <span class="ma3">
                            {{$zutil.dateformat(d.created_at)}}
                        </span>
                    </template>
                </div>
            </w-flex>
        <!-- </template> -->
          
      </template>

      <template #item-content.3>
         <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                  <td >Tarikh Bil</td>
                                  <td>No. Bil</td>
                                  <td>Keterangan</td>
                                  <td>Amaun (RM) </td>
                                  <td>Status </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="dt, index in form.perumahan_bil">
                                <td>{{$zutil.dateformat(dt.created_at)}} </td>
                                <td>{{dt.no_bil}}</td>
                                <td>{{dt.caj_keterangan}} {{dt.bulan}} - {{dt.tahun}}</td>
                                <td>{{$zutil.currency(dt.amaun)}}</td>
                                <td>
                                    <template v-if="dt.status == 1">
                                        Bayar
                                    </template>
                                    <template v-else>
                                        Belum Bayar
                                    </template>
                                </td>
                            </tr>
                       
                        </tbody>
                    </table>
                </div>
            </w-flex>

      </template>

      <template #item-content.4>
         <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" @click="cetak" bg-color="success">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
             <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">  

        <!-- <template v-if="form.lkp_inbois_status_id == 4 || form.lkp_inbois_status_id == 3">   -->
            <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                  <td >Tarikh</td>
                                  <td>Jenis Transaksi</td>
                                  <td>No. Rujukan</td>
                                  <td>Keterangan</td>
                                  <td>AMAUN DEBIT (RM)</td>
                                  <td>AMAUN KREDIT (RM)</td>
                                  <td>BAKI (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="dt, index in form.perumahan_transaksi">
                                <td>{{$zutil.dateformat(dt.tarikh)}} </td>
                                <td>{{dt.lkp_perumahan_transaksi_keterangan}}</td>
                                <td>{{dt.no_rujukan}}</td>
                                <td>{{dt.keterangan}}</td>
                                <td>{{$zutil.currency(dt.amaun_debit)}}</td>
                                <td>{{$zutil.currency(dt.amaun_kredit)}}</td>
                                <td>{{$zutil.currency(dt.baki)}}</td>
                            </tr>
                       
                        </tbody>
                    </table>
                </div>
            </w-flex>
            

            <!--  <w-flex class="mt3" wrap align-center justify-end>
                    <template v-if="form.lkp_inbois_status_id == 2 && $zutil.can('BilPelbagai Batalkan')" >
                        <w-button class="my1" bg-color="error-dark1" dark  @click="send(4)" >
                             <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                        </w-button>
                    </template>
                        &nbsp;&nbsp;

                    <template v-if="form.lkp_inbois_status_id == 2 || form.lkp_inbois_status_id == 3" >
                        <w-button bg-color="success" class="mr3" @click="cetak()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                        </w-button>
                    </template>
                        &nbsp;
                    <template v-if="form.lkp_inbois_status_id == 3" >
                        <w-button bg-color="success" class="mr3" @click="cetakResit()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak Resit
                        </w-button>
                    </template>

                   
            </w-flex> -->
        <!-- </template> -->

        </w-form>
      </template>

      <template #item-content.5>
       <!--  <w-form
            class=""
            v-model="form.valid"
            v-model:errors-count="form.errorsCount"
            @validate="onValidate"
            @success="send"
        > -->
         <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitTindakan" @success="onSuccess">
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Jenis Transaksi *
                    </h5>
                </div>
                <div class="xs9">
                    <template v-if="form.deposit1.id == null && form.bil_bulan_semasa > 0 && form.amaun_patut_kutip > 0  && form.lkp_perumahan_status_id == 1">
                        <z-lookup
                            name="jenis_transaksi"
                            :url="service_tunggakan + 'lookup/lkp_perumahan_transaksi_deposit'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_perumahan_transaksi_id"
                        />
                    </template>
                    <!-- <template v-else-if="form.bil_bulan_semasa == 0 && form.deposit1.id != null && form.amaun_patut_kutip > 0 && form.lkp_perumahan_status_id == 1"> -->
                    <template v-else-if="form.lkp_perumahan_status_id == 4">
                        <z-lookup
                            name="jenis_transaksi"
                            :url="service_tunggakan + 'lookup/lkp_perumahan_transaksi_kira'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_perumahan_transaksi_id"
                        />
                    </template>
                   <!--  <template v-else-if="form.bil_bulan_semasa == 0 && form.amaun_baki == 0 && form.tarikh_sewa_baharu >= form.bulan_tamat_bayar && form.lkp_perumahan_premis_id == 1 && form.lkp_perumahan_status_id == 4 && form.kontrak_baharu == null">
                        <z-lookup
                            name="jenis_transaksi"
                            :url="service_tunggakan + 'lookup/lkp_perumahan_transaksi_kontrak'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_perumahan_transaksi_id"
                        />
                    </template>
                     <template v-else-if="form.deposit1.id == null && form.bil_bulan_semasa == 0 && form.amaun_patut_kutip > 0  && form.lkp_perumahan_status_id == 1">
                        <z-lookup
                            name="jenis_transaksi"
                            :url="service_tunggakan + 'lookup/lkp_perumahan_transaksi'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_perumahan_transaksi_id"
                        />
                    </template> -->
                    <template v-else>
                        
                    </template>
                    <!--  <z-lookup
                            name="jenis_transaksi"
                            :url="service_tunggakan + 'lookup/lkp_perumahan_transaksi'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_perumahan_transaksi_id"
                        /> -->
                </div>
            </w-flex>
        <template v-if="form.lkp_perumahan_transaksi_id == 7">
             <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Deposit
                    </h5>
                </div>
                <div class="xs9">
                    <z-input label="Deposit *"  name="deposit_id" readonly @click="deposit" :validators="[validators.required]"/>
                </div>
            </w-flex>
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                       No. Deposit
                    </h5>
                </div>
                <div class="xs9">
                   {{form_deposit.no_cagaran}}
               </div>
            </w-flex>
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                       Keterangan
                    </h5>
                </div>
                <div class="xs9">
                   {{form_deposit.keterangan}}
               </div>
            </w-flex>
            <br>

        </template>
        <template v-else-if="form.lkp_perumahan_transaksi_id == 6">
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        No. Rujukan *
                    </h5>
                </div>
                <div class="xs9">
                    <w-input
                        class="mb4"
                        v-model="form.no_rujukan"
                        label="No. Rujukan"
                     />
                </div>
            </w-flex>
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">Amaun Hapus Kira (RM) *</h5>
                </div>
                <div class="xs9">
                    <z-money
                        v-model:originalValue="form.jumlah_amaun_bil"
                        validators="[validators.required]"
                    ></z-money>
                    <!-- <div class="w-form-el__error error" v-if="form.amaun > form.amaun_belum_inbois" style="">
                         Amaun Melebihi {{$zutil.currency(form.amaun_belum_inbois)}}
                    </div> -->
                              
                </div>
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Catatan *
                    </h5>
                </div>
                <div class="xs9">
                    <w-input
                        class="mb4"
                        v-model="form.keterangan"
                        label="Catatan"
                     />
                </div>
            </w-flex>
            <br>
             <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">Dokumen sokongan :</h5>
                </div>
                <div class="xs9"><br>
                    <a :href="form.lampiran_url">
                    {{form.lampiran_fail}}
                    </a>
                    <br>
                    <!-- <template v-if="form.lampiran_fail == null"> -->
                        <w-input
                            class="mt3"
                            outline
                            type="file"
                            v-model="files"
                        >
                        </w-input>
                   <!--  </template>
                    <template v-else>
                        <w-input
                            readonly
                            class="mt3"
                            outline
                        >
                        </w-input>
                    </template> -->
                </div>
            </w-flex><br/>

        </template>
        <!-- <template v-else-if="form.lkp_perumahan_transaksi_id == 8">
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Tarikh Mula Perjanjian *
                    </h5>
                </div>
                <div class="xs5">
                      <z-input 
                          name="bulan_mula_bayar" 
                          v-model="form.kontrak_mula"
                           type="date"/>
                </div>
            </w-flex>
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Tempoh Perjanjian *
                    </h5>
                </div>
                <div class="xs5">
                      <w-input class="mb4" type="number" v-model="form.kontrak_tempoh" v-on:keyup="Tamat(form)"  :validators="[validators.required]" />
                </div>
            </w-flex>
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Tarikh Tamat Perjanjian *
                    </h5>
                </div>
                <div class="xs5">
                    {{$zutil.dateformat(form.kontrak_tamat)}}
                </div>
            </w-flex>
            <br>
            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Harga Rumah *
                    </h5>
                </div>
                <div class="xs5">
                     <z-money
                        v-model:originalValue="form.kontrak_harga_rumah"
                        required
                    />
                </div>
            </w-flex>
            <br>
        </template> -->


            <!-- <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Amaun Deposit (RM) :
                    </h5>
                </div>
                <div class="xs9">
                    {{$zutil.currency(form.transaksi_deposit ? form.transaksi_deposit.amaun_debit : '')}}
                </div> 
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Amaun Deposit Diterima (RM) :
                    </h5>
                </div>
                <div class="xs9">
                </div> 
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Patut Kutip (RM) :
                    </h5>
                </div>
                <div class="xs9">
                    {{$zutil.currency(form.amaun_patut_kutip)}}
                </div> 
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Jumlah Kutipan Sewa (RM) :
                    </h5>
                </div>
                <div class="xs9">
                    {{$zutil.currency(form.amaun_kutipan)}}
                </div> 
            </w-flex>
            <br>

            <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Jumlah Tunggakan (RM) :
                    </h5>
                </div>
                <div class="xs9">
                    {{$zutil.currency(form.amaun_tunggakan_lebihan)}}
                </div> 
            </w-flex> -->
           
            

            <!--  <w-flex>
                <div class="xs3">
                    <h5 class="fw-semibold m0">
                        Baki Akhir Sewaan (RM) :
                    </h5>
                </div>
                <div class="xs9">
                    {{$zutil.currency(form.amaun_baki)}}
                </div> 
            </w-flex>
            <br> -->

            

            
            <w-flex class="mt3" wrap align-center justify-end>
                <!-- <template v-if="form.bil_bulan_semasa == 0 && form.amaun_baki == 0 && form.tarikh_sewa_baharu >= form.bulan_tamat_bayar && form.lkp_perumahan_premis_id == 1 && form.lkp_perumahan_status_id == 4 && form.kontrak_baharu == null"> -->
                    <template v-if="form.lkp_perumahan_premis_id == 1 && form.lkp_perumahan_status_id == 4 && form.kontrak_baharu == null">
                     <!-- <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Kontrak Baharu
                    </w-button> -->
                     <w-button
                        class="my1"
                        @click="kontrakBaharu(form)"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Kontrak Baharu
                    </w-button>
                    &nbsp;&nbsp;
                </template>

                <w-button class="my1"
                    bg-color="warning" dark
                    @click="back()" >Kembali</w-button>
                &nbsp;&nbsp;
               
                      <!-- <template v-if="form.lkp_deposit_trans_id == 1 ||form.amaun_baki < 0"> -->
                        <w-button
                            class="my1" type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent">
                            <w-icon dark tile class="mr2" >fal fa-paper-plane</w-icon>
                            Hantar
                        </w-button>
                      <!-- </template> -->
            </w-flex>
        </w-form>

      </template>
      <template #item-content.6>
        <w-flex justify-center align-center>
            <div class="w-card__content content-hardcode">
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td width="2%">No</td>
                            <td width="15%">No. Akaun</td>
                            <td>Kod Premis</td>
                            <td>Tarikh Mula Perjanjian</td>
                            <td>Tarikh Tamat Perjanjian</td>
                            <td>Tempoh Perjanjian</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(dt, index) in form.perjanjian_lama">
                            <td>{{ index + 1 }}</td>
                            <td>{{ dt.no_akaun }}</td>
                            <td>{{ dt.kod_premis }}</td>
                            <td>{{$zutil.dateformat(dt.bulan_mula_bayar)}}</td>
                            <td>{{$zutil.dateformat(dt.bulan_tamat_bayar)}}</td>
                            <td>{{ dt.tempoh_perjanjian }}</td>
                        </tr>
                        <tr v-if="form.perjanjian_lama.length == 0">
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </w-flex>
      </template>
      <template #item-content.7>
        <w-flex justify-center align-center>
            <div class="w-card__content content-hardcode">
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td width="2%">No</td>
                            <td width="15%">Tarikh</td>
                            <td>Pengguna</td>
                            <td>Status</td>
                            <td>Catatan</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(
                                dt, index
                            ) in form.jejak_audit_perumahan"
                        >
                            <td>{{ index + 1 }}</td>
                            <td>{{ dt.tarikh }}</td>
                            <td>{{ dt.user_nama }}</td>
                            <td>
                                {{ dt.tindakan_keterangan_perumahan }}
                            </td>
                            <td>{{ dt.catatan }}</td>
                        </tr>
                        <tr v-if="form.jejak_audit_perumahan.length == 0">
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </w-flex>
      </template>
    </w-tabs>

<!-- </w-form> -->

    <w-dialog
              v-model="dialogDeposit.show"
              :fullscreen="dialogDeposit.fullscreen"
              :width="dialogDeposit.width"
              :persistent="dialogDeposit.persistent"
              :persistent-no-animation="dialogDeposit.persistentNoAnimation"
              title-class="primary-light1--bg white">
              <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Deposit
              </template>
              <div class="page-wrapper-portal">
                  <w-flex justify-center align-center>
                      <div class="xs8">
                             <w-input label="No. Rujukan | Keterangan (Carian minimun 2 aksara)" v-model="carian_deposit.q" > </w-input>
                      </div>
                      <div class="xs4">
                            <w-button class="ml1" @click="cariDeposit">Cari</w-button>
                      </div>
                  </w-flex>
                  <div class="table-profil-scrol">
                  <table class="w-table ">
                      <thead>
                      <tr>
                          <th class="w-table__header w-table__header--sortable text-left">No</th>
                          <th class="w-table__header w-table__header--sortable text-left">No. Rujukan | Keterangan</th>
                          <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
                      </tr>
                      </thead>
                      <tbody>
                      
                          <tr v-for="dt, index in deposits">
                              <td class="w-table__cell text-left">
                                  {{(index+1)}}
                              </td>
                              <td class="w-table__cell ">
                                  {{dt.label.toUpperCase()}}
                              </td>
                              <td class="w-table__cell text-right">
                                  <w-radio class="mr2" v-model="form.deposit_id" :return-value="dt.value" @click="pilihDeposit(dt)"></w-radio>
                              </td>
                          </tr>
                          
                      </tbody>
                      
                  </table>
                </div>
              </div>

                <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialogDeposit.show = false">Tutup</w-button>
                </template>
          </w-dialog>

         <w-dialog v-model="dialogKontrak.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
            <template #title> Kontrak Baharu </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submitKontrak"
                        @success="success">
                                 
                                <w-flex>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            Penyewa :
                                        </h5>
                                    </div><br>
                                    <div class="xs8">
                                      <w-radios v-model="form.lkp_perumahan_profil_id" :items="PenyewaKontrak" inline ></w-radios>
                                    </div>
                                </w-flex><br>
                                <template v-if="form.lkp_perumahan_profil_id == 1">
                                    <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            No Kad Pengenalan | nama :
                                        </h5>
                                        </div>
                                        <div class="xs8">
                                            {{ form.profil_perumahan ? form.profil_perumahan.nama_id : ''}}
                                        </div>
                                    </w-flex>
                                    <br>
                                    
                                     
                                </template>
                                <template v-else-if="form.lkp_perumahan_profil_id == 2">
                                    <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                        </h5>
                                        </div>
                                        <div class="xs7">
                                           <z-input label="Sila Masukan No Kad Pengenalan | Nama"  name="profil_id" readonly @click="profil" outline :validators="[validators.required]"/>
                                        </div>
                                        <div class="xs1">
                                            &nbsp;
                                            <w-icon  @click="profilNew">fal fa-plus</w-icon>
                                        </div>
                                    </w-flex>
                                    <br>
                                    <template v-if="form.no_id">
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    No Kad Pengenalan :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.no_id.toUpperCase()}}
                                            </div>
                                        </w-flex>
                                        <br>
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    Nama :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.nama.toUpperCase()}}
                                            </div>
                                        </w-flex>
                                    </template>
                                    <template v-else>
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    No Kad Pengenalan :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                   {{form.profil_no}}
                                            </div>
                                        </w-flex>
                                        <br>
                                         <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    Nama :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.profil_nama}}
                                            </div>
                                        </w-flex>
                                    </template>
                                    <br>
                                </template> 

                        <w-flex>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                    Tarikh Mula Perjanjian *
                                </h5>
                            </div>
                            <div class="xs8">
                                  <z-input 
                                      name="bulan_mula_bayar" 
                                      v-model="form.kontrak_mula"
                                       type="date"/>
                            </div>
                        </w-flex>
                        <br>
                        <w-flex>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                    Tempoh Perjanjian *
                                </h5>
                            </div>
                            <div class="xs8">
                                  <w-input class="mb4" type="number" v-model="form.kontrak_tempoh" v-on:keyup="Tamat(form)"  :validators="[validators.required]" />
                            </div>
                        </w-flex>
                        <br>
                        <w-flex>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                    Tarikh Tamat Perjanjian *
                                </h5>
                            </div>
                            <div class="xs8">
                                {{$zutil.dateformat(form.kontrak_tamat)}}
                            </div>
                        </w-flex>
                        <br>
                        <w-flex>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                    Harga Rumah *
                                </h5>
                            </div>
                            <div class="xs8">
                                 <z-money
                                    v-model:originalValue="form.kontrak_harga_rumah"
                                    required
                                />
                            </div>
                        </w-flex>
                        <br>
                       <!--  <w-flex>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">
                                    Tunggakan lama
                                </h5>
                            </div>
                            <div class="xs8">
                                 <z-money
                                    v-model:originalValue="form.amaun_tunggakan_lama"
                                    required
                                />
                            </div>
                        </w-flex>  
                      -->
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogKontrak.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >Hantar</w-button
                    >
                </template>
        </w-dialog>

         <w-dialog v-model="dialogPemilik.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
            <template #title> Pemilik Baharu </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submitPemilik"
                        @success="success">
                                 
                                    <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            <br>
                                            Pemilik Baharu
                                        </h5>
                                        </div>
                                        <div class="xs7">
                                           <z-input label="Sila Masukan No Kad Pengenalan | Nama"  name="profil_id" readonly @click="profil" outline :validators="[validators.required]"/>
                                        </div>
                                        <div class="xs1">
                                            <br>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <w-icon  @click="profilNew">fal fa-plus</w-icon>
                                        </div>
                                    </w-flex>
                                    <br>
                                    <template v-if="form.no_id">
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    No Kad Pengenalan :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.no_id.toUpperCase()}}
                                            </div>
                                        </w-flex>
                                        <br>
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    Nama :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.nama.toUpperCase()}}
                                            </div>
                                        </w-flex>
                                    </template>
                                    <template v-else>
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    No Kad Pengenalan :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                   {{form.profil_no}}
                                            </div>
                                        </w-flex>
                                        <br>
                                         <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    Nama :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.profil_nama}}
                                            </div>
                                        </w-flex>
                                    </template>
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogPemilik.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        @click="$refs.form.validate()"
                        >Hantar</w-button
                    >
                </template>
        </w-dialog>


        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title> Potongan Gaji </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submitPotongan"
                        @success="success">
                                <w-flex>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            Potongan Gaji :
                                        </h5>
                                    </div>
                                    <div class="xs8">
                                      <w-radios v-model="form.is_potongan_gaji" :items="potongGajiItem" inline ></w-radios>
                                    </div>
                                </w-flex><br>
                            <template v-if="form.is_potongan_gaji == 1">     
                                <w-flex>
                                    <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            Pembayar :
                                        </h5>
                                    </div><br>
                                    <div class="xs8">
                                      <w-radios v-model="form.lkp_perumahan_profil_id" :items="pembayar" inline ></w-radios>
                                    </div>
                                </w-flex><br>
                                <template v-if="form.lkp_perumahan_profil_id == 1">
                                    <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            No Kad Pengenalan | nama :
                                        </h5>
                                        </div>
                                        <div class="xs8">
                                            {{ form.profil_perumahan ? form.profil_perumahan.nama_id : ''}}
                                        </div>
                                    </w-flex>
                                    <br>
                                    
                                     <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Agensi:
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                            <z-lookup
                                                :url="service_utiliti + 'lookup/perumahan_jabatan'"
                                                :sort="false"
                                                :cache="false"
                                                required
                                                outline
                                                placeholder="Sila Masukan Kod | Nama"
                                                v-model="form.perumahan_jabatan_id"
                                                @pilih="pejabatDetail(form.perumahan_jabatan_id)"
                                                :validators="[validators.required]"
                                            />
                                            </div>
                                      </w-flex>
                                      <br>
                                       <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            Jabatan :
                                        </h5>
                                        </div>
                                        <div class="xs8">
                                            <template v-if="form.perumahan_jabatan_id"> 
                                                <select v-model="form.perumahan_pejabat_id" class="inline" style="width:650px; height:30px; background-color: white;">
                                                  <option v-for="option in perumahanJabatans" :value="option.value">
                                                    {{ option.label }}
                                                  </option>
                                                </select>
                                            </template>
                                           

                                            <!-- {{PejabatItem}} -->
                                            <!-- {{perumahanJabatans}} -->
                                            <!-- <z-lookup
                                                :items="perumahanJabatans"
                                                :sort="false"
                                                :cache="false"
                                                required 
                                                placeholder="Sila Masukan Kod | Nama"
                                                v-model="form.perumahan_pejabat_id"
                                                :validators="[validators.required]"
                                            /> -->
                                             <!-- <w-radios v-model="form.perumahan_pejabat_id" :items="perumahanJabatans" inline ></w-radios> -->
                                            
                                        </div>
                                    </w-flex>
                                    <br>
                                    <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Bulan Mula Potongan gaji:
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                          <z-lookup name="akaun" 
                                              :url="service_utiliti + 'lookup/bulan'"
                                              :sort="false"
                                              :cache="false"
                                              v-model="form.bulan"
                                                outline
                                              :validators="[validators.required]" >
                                          </z-lookup>
                                        </div>
                                      </w-flex><br>
                                      <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Tahun :
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                            <w-input class="mb4" type="number" v-model="form.tahun" outline :validators="[validators.required]" />
                                        </div>
                                      </w-flex><br>
                                      <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Kadar Potongan Gaji (MR):
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                          <z-money 
                                            v-model:originalValue="form.kadar_bulanan"
                                            validators="[validators.required]" outline>
                                          </z-money>
                                        </div>
                                      </w-flex>
                                </template>
                                <template v-else-if="form.lkp_perumahan_profil_id == 2">
                                    <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                        </h5>
                                        </div>
                                        <div class="xs7">
                                           <z-input label="Sila Masukan No Kad Pengenalan | Nama"  name="profil_id" readonly @click="profil" outline :validators="[validators.required]"/>
                                        </div>
                                        <div class="xs1">
                                            &nbsp;
                                            <w-icon  @click="profilNew">fal fa-plus</w-icon>
                                        </div>
                                    </w-flex>
                                    <br>
                                    <template v-if="form.no_id">
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    No Kad Pengenalan :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.no_id.toUpperCase()}}
                                            </div>
                                        </w-flex>
                                        <br>
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    Nama:
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.nama.toUpperCase()}}
                                            </div>
                                        </w-flex>
                                    </template>
                                    <template v-else>
                                        <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    No Kad Pengenalan :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                   {{form.profil_no}}
                                            </div>
                                        </w-flex>
                                        <br>
                                         <w-flex>
                                            <div class="xs4">
                                                <h5 class="fw-semibold m0">
                                                    Nama :
                                                </h5>
                                            </div>
                                            <div class="xs8">
                                                {{form.profil_nama}}
                                            </div>
                                        </w-flex>
                                    </template>
                                    <br>
                                       <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Agensi:
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                            <z-lookup
                                                :url="service_utiliti + 'lookup/perumahan_jabatan'"
                                                :sort="false"
                                                :cache="false"
                                                required 
                                                outline
                                                placeholder="Sila Masukan Kod | Nama"
                                                v-model="form.perumahan_jabatan_id"
                                                :validators="[validators.required]"
                                            />
                                            </div>
                                      </w-flex>
                                      <br>
                                       <w-flex>
                                        <div class="xs4">
                                        <h5 class="fw-semibold m0">
                                            Jabatan :
                                        </h5>
                                        </div>
                                        <div class="xs8">
                                            <template v-if="form.perumahan_jabatan_id"> 
                                                <select v-model="form.perumahan_pejabat_id" class="inline" style="width:650px; height:30px; background-color: white;">
                                                  <option v-for="option in perumahanJabatans" :value="option.value">
                                                    {{ option.label }}
                                                  </option>
                                                </select>
                                            </template>
                                            <!-- {{PejabatItem}} -->
                                            <!-- {{perumahanJabatans}} -->
                                            <!-- <z-lookup
                                                :options="PejabatItem1"
                                                :sort="false"
                                                :cache="false"
                                                required 
                                                placeholder="Sila Masukan Kod | Nama"
                                                v-model="form.perumahan_pejabat_id"
                                                :validators="[validators.required]"
                                            /> -->
                                             <!-- <w-radios v-model="form.perumahan_pejabat_id" :items="perumahanJabatans" inline ></w-radios> -->
                                            
                                        </div>
                                    </w-flex>
                                    <br>
                                    <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Bulan Mula Potongan gaji:
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                          <z-lookup name="akaun" 
                                              :url="service_utiliti + 'lookup/bulan'"
                                              :sort="false"
                                              :cache="false"
                                              outline
                                              v-model="form.bulan"
                                              :validators="[validators.required]" >
                                          </z-lookup>
                                        </div>
                                      </w-flex><br>
                                      <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Tahun :
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                            <w-input class="mb4" type="number" v-model="form.tahun" outline :validators="[validators.required]" />
                                        </div>
                                      </w-flex><br>
                                      <w-flex>
                                        <div class="xs4">
                                            <h5 class="fw-semibold m0">
                                                Kadar Potongan Gaji (MR):
                                            </h5>
                                        </div>
                                        <div class="xs8">
                                          <z-money 
                                            v-model:originalValue="form.kadar_bulanan" outline
                                            validators="[validators.required]">
                                          </z-money>
                                        </div>
                                      </w-flex>
                                </template>   
                                   
                            </template>
                        
                     
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >Daftar</w-button
                    >
                </template>
        </w-dialog>

         <w-dialog
              v-model="dialogProfil.show"
              :fullscreen="dialogProfil.fullscreen"
              :width="dialogProfil.width"
              :persistent="dialogProfil.persistent"
              :persistent-no-animation="dialogProfil.persistentNoAnimation"
              title-class="primary-light1--bg white">
              <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
              </template>
              <div class="page-wrapper-portal">
                  <w-flex justify-center align-center>
                      <div class="xs8">
                             <w-input label="No KP | Nama (Carian minimun 2 aksara)" v-model="carian_profil.q" > </w-input>
                      </div>
                      <div class="xs4">
                            <w-button class="ml1" @click="cariProfil">Cari</w-button>
                      </div>
                  </w-flex>
                  <div class="table-profil-scrol">
                  <table class="w-table ">
                      <thead>
                      <tr>
                          <th class="w-table__header w-table__header--sortable text-left">No</th>
                          <th class="w-table__header w-table__header--sortable text-left">No KP | Nama</th>
                          <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
                      </tr>
                      </thead>
                      <tbody>
                      
                          <tr v-for="dt, index in profils">
                              <td class="w-table__cell text-left">
                                  {{(index+1)}}
                              </td>
                              <td class="w-table__cell ">
                                  {{dt.label.toUpperCase()}}
                              </td>
                              <td class="w-table__cell text-right">
                                  <w-radio class="mr2" v-model="form.profil_id" :return-value="dt.value" @click="pilihProfil(dt)"></w-radio>
                              </td>
                          </tr>
                          
                      </tbody>
                      
                  </table>
                </div>
              </div>

                <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialogProfil.show = false">Tutup</w-button>
                </template>
          </w-dialog>

            <w-dialog v-model="dialogProfilNew.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Tambah Profil
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submitProfil" @success="success">
                        <template ></template><br>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                           <div class="title4 mb2">Kategori Profil*</div>
                            <w-radios :items="kategori" 
                                v-model="form_profil.kategori"
                                :sort="false"
                                :cache="false" 
                                :validators="[validators.required]"
                                inline></w-radios>
                            </div>

                           </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. KP/No. Syarikat *"  
                              name="No. ID" 
                              v-model="form_profil.no_id" 
                              :validators="[validators.required]"/>
                            <z-input 
                              label="Nama *" 
                              name="Nama" 
                              v-model="form_profil.nama" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Alamat *" 
                              name="Alamat" 
                              v-model="form_profil.alamat1" 
                              :validators="[validators.required]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat2" 
                              v-model="form_profil.alamat2" />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              name="Alamat3" 
                              v-model="form_profil.alamat3" />
                        </w-flex>
                        <z-lookup 
                              label="Poskod" 
                              name="poskod" 
                              :url='service_bil_pelbagai+"lookup/lkp_poskod"' 
                              :sort="false" :cache="false"
                              v-model="form_profil.lkp_poskod_id"/><br>
                            <w-flex justify-center align-center>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form_profil.negeri}}</td>
                                  </tr>
                              </div>
                            </w-flex><br>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="No. Telefon" 
                              name="No. Telefon" 
                              v-model="form_profil.no_tel" 
                              :validators="[validators.numeric]"/>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input 
                              label="Emel"  
                              name="Email" 
                              v-model="form_profil.emel"/>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialogProfilNew.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">Simpan</w-button>
                </template>
            </w-dialog>


           

  
    </z-page>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_tunggakan +'perumahan',
    reload: true,
    activeTab : 0,
    loading: true,
    form_deposit: {},
    carian_deposit : {q: ''},
    deposits : [],
    form_cari : {},
    carian_profil : {q: ''},
    profils : [],
    form_perjanjian : {},
    form_profil :{},
    dialogDeposit: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },
    dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
        },
    dialogKontrak: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
        },
    dialogPemilik: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
        },
    dialogProfil: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
    },
    dialogProfilNew: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
    },


        form_gaji: {},
        perumahanJabatans: [],
       
        // jenis: [
        //         { label: "CUKAI", value: 2 },
        //         { label: "BIL PELBAGAI", value: 1 },
        //         { label: "PENDIDIKAN", value: 3 },
        //         { label: "TUNTUTAN", value: 4 },
        //         { label: "PERUMAHAN", value: 5 },
        //     ],
        potongGajiItem: [
                {
                    value: 1,
                    label: "Ya",
                },
                {
                    value: 0,
                    label: "Tidak",
                },
            ],
        pembayar: [
                {
                    value: 1,
                    label: "Pemilik",
                },
                {
                    value: 2,
                    label: "Pembayar Lain - lain",
                },
            ],
        kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],

        PenyewaKontrak: [
                {
                    value: 1,
                    label: "Penyewa Sama",
                },
                {
                    value: 2,
                    label: "Penyewa Lain",
                },
            ],
      
      tabs: [
          { title: 'Profil', content: '' },
          { title: 'Deposit', content: '' },
          { title: 'Bil', content: '' },
          { title: 'Transaksi', content: '' },
          { title: 'Tindakan', content: '' },
          { title: 'Perjanjian', content: '' },
          { title: 'Jejak Audit', content: '' },
      ],
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Perumahan', route: '/perumahan' },
        { label: 'Butiran Perumahan', route: '/perumahan/'+this.id },
      ],
      
    }
  },
    methods: {
    
    deposit(){
      this.dialogDeposit.show = 1
    },

    potongGaji(form) {
          // this.dialog.show = 1;
        if (this.form.is_potongan_gaji == 1) {
            if (this.form.profil_perumahan_pembayar.lkp_perumahan_profil_id == 1)
            {
              this.form.profil_id = this.form.profil_perumahan_pembayar.profil_id;
              this.form.nama_profil = this.form.profil_perumahan_pembayar.nama_profil;
              this.form.no_id = this.form.profil_perumahan_pembayar.no_profil; 
              this.form.perumahan_pejabat_id = this.form.pejabat_perumahan.id;
              this.form.perumahan_jabatan_id = this.form.pejabat_perumahan.perumahan_jabatan_id;
              this.form.tahun = this.form.perumahan_potongan_gaji.tahun;
              this.form.bulan = this.form.perumahan_potongan_gaji.bulan;
              this.form.amaun = this.form.perumahan_potongan_gaji.amaun;
              this.form.is_potong_gaji = this.form.is_potong_gaji;
              this.form.lkp_perumahan_profil_id = this.form.profil_perumahan_pembayar.lkp_perumahan_profil_id;
              this.dialog.show = 1;
            } else if (this.form.profil_perumahan_pembayar.lkp_perumahan_profil_id == 2) {
              this.form.profil_id = this.form.profil_perumahan_pembayar.profil_id;
              this.form.profil_nama = this.form.profil_perumahan_pembayar.nama_profil;
              this.form.profil_no = this.form.profil_perumahan_pembayar.no_profil; 
              this.form.perumahan_pejabat_id = this.form.pejabat_perumahan.id;
              this.form.perumahan_jabatan_id = this.form.pejabat_perumahan.perumahan_jabatan_id;
              this.form.tahun = this.form.perumahan_potongan_gaji.tahun;
              this.form.bulan = this.form.perumahan_potongan_gaji.bulan;
              this.form.amaun = this.form.perumahan_potongan_gaji.amaun;
              this.form.is_potong_gaji = this.form.is_potong_gaji;
              this.form.lkp_perumahan_profil_id = this.form.profil_perumahan_pembayar.lkp_perumahan_profil_id;
              this.dialog.show = 1;
            }
            else{
               this.dialog.show = 1; 
            }
         
        } else {
          //    this.item.profil_id = this.form.profil_id;
          // this.item.nama_profil = this.form.nama_profil;
          // this.item.no_id = this.form.no_id; 
          // this.item.is_potong_gaji = this.form.is_potong_gaji;
          // this.item.pendidikan_pejabat_id = this.form.pendidikan_pejabat_id;
          // this.item.pendidikan_jabatan_id = this.form.pendidikan_jabatan_id;
          // this.item.amaun = this.form.jumlah_ansuran_bulanan;
          // this.item.amaun_lain = this.form.jumlah_ansuran_bulanan;
          this.dialog.show = 1;
          
        }
    },

    kontrakBaharu(form){
        this.dialogKontrak.show = 1;
    },

    pemilikBaharu(form){
        this.dialogPemilik.show = 1;
    },

    profil(){
      this.dialogProfil.show = 1
    },
    profilNew(){
      this.dialogProfilNew.show = 1
    },

    cariProfil(){
      if(this.carian_profil.q.length > 1){
        this.$zcomm.post(this.service_bil_pelbagai+"lookup/profil", this.carian_profil, {})
        .then(res => {
          console.log(res)
            this.profils = res
          })
      }
    },

    pilihProfil(dt){
      this.form.profil_keterangan = dt.label;
      this.form_cari.id = dt.value;
      this.profilDetail();
    },

     profilDetail() {
        // alert('w234')
      
      this.$zcomm.get(this.service_bil_pelbagai+'profil/'+this.form_cari.id).then(res => {
              this.form.profil_id_lain = res.id;
              this.form.no_id = res.no_id;
              this.form.nama = res.nama;
              
            });
      this.dialogProfil.show = false
    },
    
    submitProfil() {
        
            if (this.dialog.valid == true) {
            //     this.form.valid = false

            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                
                    this.$zcomm.post(this.service_bil_pelbagai+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialogProfilNew.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.profil_id_lain = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.alamat2 = res.alamat2;
                          this.form.alamat3 = res.alamat3;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                          this.form.kategori = res.kategori;
                            // this.$inertia.visit(this.$page.url)
                          
                        })
                        .finally(() => {
                            this.dialog.loading = false;
                          this.dialogProfilNew.show = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                        this.cariProfil();
                
            }
        },

   
    cariDeposit(){
      if(this.carian_deposit.q.length > 1){
        this.$zcomm.post(this.service_tunggakan+"lookup/deposit", this.carian_deposit, {})
        .then(res => {
          console.log(res)
            this.deposits = res
          })
      }
    },

    pilihDeposit(dt){
      this.form.deposit_keterangan = dt.label;
      this.form_cari.id = dt.value;
      this.depositDetail();
    },

    depositDetail() {
        // alert('w234')
      
      this.$zcomm.get(this.service_tunggakan+'deposit/'+this.form_cari.id).then(res => {
              this.form_deposit.deposit_id = res.id;
              this.form_deposit.no_cagaran = res.no_cagaran;
              this.form_deposit.keterangan = res.keterangan;
              
            });
      this.dialogDeposit.show = false
    },

    pejabatDetail() {
        // alert(this.form.perumahan_jabatan_id);
        
            this.perumahanJabatans =[];
        this.$zcomm.get(this.service_utiliti+'lookup/pejabat_detail/'+this.form.perumahan_jabatan_id).then(res => {
                  this.perumahanJabatans = res;
                });
        //  var param = {
        //               perumahan_jabatan_id : this.form.perumahan_jabatan_id,
        //           }
        // this.$zcomm.post(this.service_utiliti+'lookup/pejabat_detail' ,param).then(res => {
        //           // this.PejabatItem = res;
        //           // this.perumahan_jabatan_id = res.perumahan_jabatan_id;
        //         });
        },

    poskodDetail() {
      
    this.$zcomm.get(this.service_bil_pelbagai+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
              this.form_profil.negeri = res.negeri;
              this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
              this.form_profil.bandar = res.bandar;
              this.form_profil.lkp_jenis_alamat_id = 1;
            });
    },


    submitTindakan(){
     // alert('asssd');

            if (this.form.valid == true) {
                this.form.loading = true
                // this.form.valid = false
              this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      // alert(res);
                        this.activeTab=3;
                        // this.activeTab=2;
                        // this.upload(res.id);
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                    
                     // this.getData();
                        this.upload(this.form.id);
                     this.form.loading = false;
                  });
              }
         
    },

    submitPotongan() {
              if (this.form.lkp_perumahan_profil_id ==1) {
                  var param = {
                      id : this.form.id,
                      bulan : this.form.bulan,
                      tahun : this.form.tahun,
                      amaun : this.form.kadar_bulanan,
                      profil_id : this.form.profil_id,
                      lkp_perumahan_profil_id : this.form.lkp_perumahan_profil_id,
                      is_potongan_gaji : this.form.is_potongan_gaji,
                      // perumahan_jabatan_id : this.form.perumahan_jabatan_id,
                      perumahan_pejabat_id : this.form.perumahan_pejabat_id,
                    }
              } else {
                  var param = {
                      id : this.form.id,
                      bulan : this.form.bulan,
                      tahun : this.form.tahun,
                      amaun : this.form.kadar_bulanan,
                      lkp_perumahan_profil_id : this.form.lkp_perumahan_profil_id,
                      profil_id : this.form.profil_id_lain,
                      is_potongan_gaji : this.form.is_potongan_gaji,
                      // pendidikan_jabatan_id : this.item.perumahan_jabatan_id_lain,
                      perumahan_pejabat_id : this.form.perumahan_pejabat_id,
                    }
              }
            this.$zcomm
                .post(this.service_tunggakan + "perumahan/potongan_gaji/" +
                    this.form.id, param)
                .then((res) => {
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                })
                .finally(() => {
                    this.$zutil.notify("Rekod Telah Berjaya Disimpan");
                    if (this.form.is_potongan_gaji != null) {
                        // this.$inertia.visit(this.$route('perumahan-agensi.agensi.show', this.form.perumahan_pejabat_id))   
                    }else{
                       this.activeTab=1;
                        this.dialog.loading = false;
                    }
                    // this.getData();  
                    //

                });

            // }
        },

        submitKontrak() {
              if (this.form.lkp_perumahan_profil_id ==1) {
                  var param = {
                      id : this.form.id,
                      kontrak_mula : this.form.kontrak_mula,
                      kontrak_tamat : this.form.kontrak_tamat,
                      kontrak_tempoh : this.form.kontrak_tempoh,
                      kontrak_harga_rumah : this.form.kontrak_harga_rumah,
                      // profil_id : this.form.profil_id,
                    }
              } else {
                  var param = {
                      id : this.form.id, 
                      kontrak_mula : this.form.kontrak_mula,
                      kontrak_tamat : this.form.kontrak_tamat,
                      kontrak_tempoh : this.form.kontrak_tempoh,
                      kontrak_harga_rumah : this.form.kontrak_harga_rumah,
                      profil_id : this.form.profil_id_lain,
                    }
              }
            this.$zcomm
                .post(this.service_tunggakan + "perumahan/new_kontrak/" +
                    this.form.id, param)
                .then((res) => {
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                })
                .finally(() => {
                    this.$zutil.notify("Rekod Telah Berjaya Disimpan");
                        this.$inertia.visit(this.$route('perumahan.index'))
                    
                    // this.getData();  
                    //

                });

            // }
        },

        submitPemilik() {
                  var param = {
                      id : this.form.id, 
                      profil_id : this.form.profil_id_lain,
                    }
            this.$zcomm
                .post(this.service_tunggakan + "perumahan/pemilik_baharu/" +
                    this.form.id, param)
                .then((res) => {
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                })
                .finally(() => {
                    this.$zutil.notify("Rekod Telah Berjaya Disimpan");
                        // this.$inertia.visit(this.$route('perumahan.index'))
                    
                    // this.getData();  
                    //

                });

            // }
        },


    // Kontrak(id) {

    //  // alert(id);
    //   this.$zcomm.get(this.resourceurl + '/kontrak/'+id)
    //       .then(res => {

    //           // this.$inertia.visit(this.$route('kutipan.mel.index'))
    //       })
         
    //       .catch(err => {

    //       })
    //       .finally(() => {
    //           // this.$inertia.visit(this.$route('kutipan.mel.index'))
    //       });
    //   },

    
    upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\Perumahan");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    // this.getData();
                    this.activeTab=1;
                    // this.submitLoading=true;
                    // this.$inertia.visit(this.$route('pendidikan.index'));
                })
                .catch((err) => {})
                .finally(() => {});
        },

  
    // getData()  {
    //       var app = this;

    //       if(this.id){
    //         if(this.id > 0){
    //           this.$zcomm.get(this.service_tunggakan +'perumahan/'+this.id+''+window.location.search).then(res => {
    //             this.form = res;

    //           })
    //           .finally(() => {

    //             this.loading = false
    //           });
    //         }
    //       }
          
          
    //     },

    Tamat(form){
        
            // alert(form_perjanjian.bulan_mula_bayar);
            this.akhir = new Date(form.kontrak_mula);
            // alert(this.akhir);
            var akhir  = this.akhir.setMonth(this.akhir.getMonth()+ form.kontrak_tempoh);
            akhir = new Date(akhir);
            form.kontrak_tamat = akhir.toISOString().split('T')[0];
            this.Rumah(form);
    },

    Rumah(form){
        form.kontrak_harga_rumah = form.harga_rumah;
    },

    cetak(td)
      {
            window.location.href = this.service_tunggakan+'perumahan/cetak_transaksi/'+this.id;
      },

       Deposit(){
            this.$inertia.visit(this.$route('deposit.show', this.form.deposit1.id))
        },

    
     
  
  },
  watch: {
     // "form.perumahan_pejabat_id": function (q) {
     //        this.pejabatDetail();
     //    },
    "form.perumahan_jabatan_id": function (q) {
            this.pejabatDetail();
        },
    'form_cari.id': function(q) {
                this.profilDetail();
        },
    'form_profil.lkp_poskod_id': function(q) {
                this.poskodDetail();
        },


  },
  mounted() {
    // this.getData();
    
      
  },
    
}
</script>